module.exports = __webpack_public_path__ + "img/cube.ef6966d9.svg";